import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Mode de développement - utilise des mocks
const DEV_MODE = false;

// Configuration Firebase pour le développement - projet de test public
const firebaseConfig = {
  apiKey: "AIzaSyD8kvBjiU8SXJo4xEoWkiO_hD2lOldE-cc",
  authDomain: "allure---jtr.firebaseapp.com",
  projectId: "allure---jtr",
  storageBucket: "allure---jtr.firebasestorage.app",
  messagingSenderId: "672930916322",
  appId: "1:672930916322:web:da15c1673c50fe00723bbb",
  measurementId: "G-9DQKDYHNWF"
};


// Initialise Firebase une seule fois avec votre vraie configuration
const app = initializeApp(firebaseConfig);

// Exports pour le reste de l'app
export const auth      = getAuth(app);
export const db        = getFirestore(app);
export const storage   = getStorage(app);
export const analytics = getAnalytics(app);

export default app;

// Mode de développement - exports des mocks
if (DEV_MODE) {
  console.log('🔥 Mode de développement activé - Utilisation des mocks Firebase');
}
 